// extracted by mini-css-extract-plugin
export var copyableField = "_mu-4";
export var customerBadge = "_mu-0";
export var customerInfoTitle = "_mu-2";
export var details = "_mu-1";
export var dropdownContainer = "_mu-5";
export var dropdownImage = "_mu-6";
export var editAssigneeForm = "_mu-a";
export var editButton = "_mu-3";
export var email = "_mu-7";
export var hidden = "_mu-d";
export var input = "_mu-8";
export var saveButton = "_mu-b";
export var shopifyIcon = "_mu-c";
export var suggestionBadge = "_mu-e";
export var suggestionText = "_mu-f";
export var username = "_mu-9";